/* eslint-disable */

var hostinfo = {
  dev_api_server: "rechner-backend.localhost:8080",
  dev_machine: "SAG-JJ",
  requestMethod: "GET",
}
export default hostinfo
/* eslint-enable */